/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { FindInvoicesByOrganizationIdQueryResponse } from "../types/FindInvoicesByOrganizationId.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findInvoicesByOrganizationIdQueryKey = () =>
  [{ url: "/v1/invoice/find-invoices-by-organization-id" }] as const

export type FindInvoicesByOrganizationIdQueryKey = ReturnType<
  typeof findInvoicesByOrganizationIdQueryKey
>

/**
 * @summary Find invoices by organization id
 * {@link /v1/invoice/find-invoices-by-organization-id}
 */
export async function findInvoicesByOrganizationId(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindInvoicesByOrganizationIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/invoice/find-invoices-by-organization-id`,
    ...requestConfig,
  })
  return res
}

export function findInvoicesByOrganizationIdQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findInvoicesByOrganizationIdQueryKey()
  return queryOptions<
    ResponseConfig<FindInvoicesByOrganizationIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindInvoicesByOrganizationIdQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findInvoicesByOrganizationId({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find invoices by organization id
 * {@link /v1/invoice/find-invoices-by-organization-id}
 */
export function useFindInvoicesByOrganizationId<
  TData = ResponseConfig<FindInvoicesByOrganizationIdQueryResponse>,
  TQueryData = ResponseConfig<FindInvoicesByOrganizationIdQueryResponse>,
  TQueryKey extends QueryKey = FindInvoicesByOrganizationIdQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindInvoicesByOrganizationIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findInvoicesByOrganizationIdQueryKey()

  const query = useQuery(
    {
      ...findInvoicesByOrganizationIdQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
